var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverdueDeposits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.125,
    height: 15,
    viewBox: "0 0 13.125 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M5.156-11.25a1.356,1.356,0,0,1,1,.41,1.356,1.356,0,0,1,.41,1V.469a1.356,1.356,0,0,1-.41,1,1.356,1.356,0,0,1-1,.41H-5.156a1.356,1.356,0,0,1-1-.41,1.356,1.356,0,0,1-.41-1V-9.844a1.356,1.356,0,0,1,.41-1,1.356,1.356,0,0,1,1-.41H-3.75v-1.523a.311.311,0,0,1,.352-.352h.234a.311.311,0,0,1,.352.352v1.523H2.813v-1.523a.311.311,0,0,1,.352-.352H3.4a.311.311,0,0,1,.352.352v1.523Zm-10.312.938a.456.456,0,0,0-.337.132.456.456,0,0,0-.132.337v1.406H5.625V-9.844a.456.456,0,0,0-.132-.337.456.456,0,0,0-.337-.132ZM5.156.938A.451.451,0,0,0,5.625.469V-7.5H-5.625V.469a.456.456,0,0,0,.132.337.456.456,0,0,0,.337.132Zm-5.479-7.5H.322a.364.364,0,0,1,.264.117.279.279,0,0,1,.088.264L.5-2.666a.316.316,0,0,1-.352.322H-.146A.316.316,0,0,1-.5-2.666L-.674-6.182a.228.228,0,0,1,0-.161A.267.267,0,0,1-.586-6.46a.77.77,0,0,1,.117-.073A.326.326,0,0,1-.322-6.562ZM.586-1.523A.8.8,0,0,1,.82-.937a.8.8,0,0,1-.234.586A.8.8,0,0,1,0-.117.8.8,0,0,1-.586-.352.8.8,0,0,1-.82-.937a.8.8,0,0,1,.234-.586A.8.8,0,0,1,0-1.758.8.8,0,0,1,.586-1.523Z",
    transform: "translate(6.563 13.125)",
    fill: "#7f7f7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdueDeposits);
export default __webpack_public_path__ + "static/media/overdue-deposits.9e7191512540bfd280d7cea48c47bb80.svg";
export { ForwardRef as ReactComponent };